PJQ.views.bidForms.BidFormEditorSelector = PJQ.views.BaseView.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.BIDFORMS, 'Editor-Selector'),
        subTemplates: {
            editorSelectorGroupBidForms: new PJQ.templating.Template(PJQ.constants.modules.BIDFORMS, 'Editor-Selector-Group-BidForms')
        },
        bidFormTemplate: null
    },
    events: {
        "click .bid-form-project-links a": "selectProjectBidForm",
        "keyup .bid-form-group-search": "renderGroupBidForms",
        "click .bid-form-group": "selectGroup",
        "click .bid-form-add-bidders-simple": "addBiddersSimple",
        "click .bid-form-add-bidders-per-contact": "addBiddersFromContacts",
        "click .btn-add-trades": "addTrades",
        "click .bid-form-add-bidders-project": "addBiddersFromProject",
        "click .bid-form-new-contact": "newContact",
        "click .export-project-bid-forms": "exportBidForms",
        "click .btn-bid-form-settings": "viewSettings",
        "click .btn-save-as-template": "saveAsTemplate",
        "click .btn-import-template": "importTemplate",
        "click .btn-seal-bids": "sealBids",
        "click .btn-view-sealed-bid-contacts": "viewSealedBidContacts",
        "click .btn-unseal-bids": "unsealBids"
    },
    beforeFirstRender: function () {
        let fnSettings;
        if (this.options.project != null) {
            fnSettings = _.bind(this.options.project.fetchBidFormSettings, this.options.project);
        } else {
            fnSettings = _.bind(PJQ.app.session.fetchBidFormSettings, PJQ.app.session);
        }

        fnSettings(_.bind(function (settings) {
            this.options.settings = settings;
            if (this.options.bidFormTemplate != null) {
                this.collection = this.options.bidFormTemplate.groupBidForms;
                this.collection.isFetched = true;
                this.render();
            } else {
                this.listenTo(this.collection, "reset", this.render);
                this.collection.fetch({
                    success: _.bind(function () {
                        this.render();
                    }, this),
                    error: _.bind(function () {
                        this.render();
                    }, this)
                });
            }
        }, this));
    },
    beforeRender: function () {
        if (this.collection && this.collection.projectBidForm) {
            this.projectBidForm = this.collection.projectBidForm;
        } else if (this.collection == null && this.options.bidFormTemplate) {
            this.collection = this.options.bidFormTemplate.groupBidForms;
            this.collection.isFetched = true;
        }
    },
    renderData: function () {
        this.options.canEdit = this.options.project != null ? this.options.project.hasPermission('messaging.canManage') : true;
        return {
            collection: this.collection,
            template: this.options.bidFormTemplate,
            project: this.options.project,
            canEdit: this.options.canEdit,
            settings: this.options.settings,
            isBidFormAdmin: this.options.project != null ? this.options.project.hasPermission('bidForms.isAdmin') : false
        };
    },
    afterRender: function () {
        if (!this.collection || !this.collection.isFetched) {
            this.loader = new PJQ.Loader(this.$('.bid-form-select-container'));
            return;
        } else if (this.loader) {
            this.loader.remove();
        }

        this.searchBar = this.$('.bid-form-group-search');
        this.renderGroupBidForms();

        if (_.size(this.collection.models) > 0 && this.options.initProposalId > 0) {
            PJQ.app.options.initProposal = new PJQ.models.bidForms.Proposal({
                projectId: PJQ.app.session.project.id,
                proposalId: this.options.initProposalId
            });
            PJQ.app.options.initProposal.fetch({
                success: _.bind(function () {
                    let bidForm = _.find(this.collection.models, function (model) {
                        return model.get('bidFormId') === PJQ.app.options.initProposal.get('bidFormId');
                    }, this);
                    if (bidForm != null) {
                        this.renderSubview(bidForm.id);
                    }
                }, this)
            });
            this.options.initProposalId = null;
        } else if (_.size(this.collection.models) > 0 && this.options.initGroupId > 0) {
            this.selectedBidForm = _.find(this.collection.models, function (bidForm) {
                if (bidForm.bidPackage != null) {
                    return bidForm.bidPackage.get('bidPackageId') === this.options.initGroupId;
                }
                return bidForm.get('groupId') === this.options.initGroupId;
            }, this);
            if (this.selectedBidForm != null) {
                this.renderBidFormEditor();
            }
            this.options.initBidFormId = null;
        } else {
            this.renderSubview();
        }
    },
    renderGroupBidForms: function (refresh) {
        let fnContinue = _.bind(function() {
            let data = {
                models: this.getFilteredGroupBidForms(),
                selectedBidForm: this.selectedBidForm
            };
            this.renderSubTemplate(false, this.options.subTemplates.editorSelectorGroupBidForms, this.$('.bid-form-group-selector-container'), data);
        }, this);

        if (refresh) {
            this.collection.fetch({
                success: _.bind(function () {
                    this.render();
                }, this),
                error: _.bind(function () {
                    this.render();
                }, this)
            });
        }
        else
            fnContinue();
    },
    getFilteredGroupBidForms: function () {
        let search = this.searchBar.length > 0 ? this.searchBar.val().toLowerCase().trim() : "",
            sortedModels;
        if (this.options.settings.get('isUsingBidPackages') || (this.options.bidFormTemplate != null && this.options.bidFormTemplate.get('bidPackageTemplateId'))) {
            sortedModels = _.sortBy(this.collection.models, function (model) {
                return model.get('bidPackage').name;
            })
        } else {
            sortedModels = sortedModels = _.sortBy(this.collection.models, function (model) {
                return model.get('group').groupName;
            })
        }
        return _.filter(sortedModels, function (model) {
            if (model.get('bidPackageId') > 0 && model.get('bidPackage') != null) {
                return model.get('bidPackage') && model.get('bidPackage').name.toLowerCase().indexOf(search) > -1;
            } else {
                return model.get('group') && model.get('group').groupName && model.get('group').groupName.toLowerCase().indexOf(search) > -1;
            }
        }, this);
    },
    renderSubview: function (id) {
        if (id != null) {
            this.selectedBidForm = this.collection.get({cid: id});
            this.renderBidFormEditor();
        } else {
            this.selectedBidForm = null;
            this.renderBidFormsSummary();
        }
    },
    clearSubView: function () {
        if (this.bidFormEditor) {
            this.bidFormEditor.undelegateEvents();
            this.bidFormEditor.stopListening();
        }

        if (this.summaryView) {
            this.summaryView.undelegateEvents();
            this.summaryView.stopListening();
        }
    },
    renderBidFormsSummary: function () {
        if (this.options.project != null) {
            PJQ.app.router.navigate('projects/' + this.options.project.id.toString() + '/bidforms', {
                trigger: false
            });
        }

        this.clearSubView();

        let summary = new PJQ.collections.bidForms.BidFormsSummary(null, {
            templateId: this.options.bidFormTemplate ? this.options.bidFormTemplate.id : null,
            projectId: this.options.project ? this.options.project.id : null
        });
        summary.fetch({
            success: _.bind(function () {
                this.summaryView = new PJQ.views.bidForms.BidFormsSummary({
                    el: this.$('.bid-form-editor'),
                    collection: summary,
                    settings: this.options.settings,
                    project: this.options.project,
                    bidFormTemplate: this.options.bidFormTemplate,
                    onDeleteBidForm: _.bind(function (model) {
                        if (!this.options.settings.get('isUsingBidPackages'))
                            this.collection.remove(model.id);
                        this.renderGroupBidForms(this.options.settings.get('isUsingBidPackages'));
                    }, this),
                    onDeleteBidForms: _.bind(function () {
                        this.renderGroupBidForms(true);
                    }, this),
                    onViewBidForm: _.bind(function (model, view) {
                        this.selectedBidForm = this.collection.get(model.id);
                        this.renderBidFormEditor(view);
                    }, this)
                });
            }, this)
        });
    },
    renderBidFormEditor: function (activeView = null) {
        if (this.options.project != null) {
            if (this.selectedBidForm.get('groupId') > 0) {
                PJQ.app.router.navigate('projects/' + this.options.project.id.toString() + '/bidforms/' + this.selectedBidForm.get('groupId'), {
                    trigger: false
                });
            } else if (this.selectedBidForm.get('bidPackageId') > 0) {
                PJQ.app.router.navigate('projects/' + this.options.project.id.toString() + '/bidforms/' + this.selectedBidForm.get('bidPackageId'), {
                    trigger: false
                });
            } else {
                PJQ.app.router.navigate('projects/' + this.options.project.id.toString() + '/bidforms', {
                    trigger: false
                });
            }
        }

        if (activeView == null && this.bidFormEditor != null) {
            activeView = this.bidFormEditor.getActiveView();
        }

        this.clearSubView();

        let fnRender = _.bind(function () {

            this.$('.bid-form-group[data-cid="' + this.selectedBidForm.cid + '"]').find('.unviewed-proposal-count').remove();
            this.bidFormEditor = new PJQ.views.bidForms.BidFormEditorContainer({
                el: this.$('.bid-form-editor'),
                project: this.options.project,
                model: this.selectedBidForm,
                projectBidForm: this.projectBidForm,
                settings: this.options.settings,
                activeView: activeView,
                collection: this.collection
            });

            $('.nav-content').scrollTop(0);
        }, this);
        if (this.selectedBidForm != null) {
            let groupsNavContainer = this.$('.bid-form-group-selector-container');
            groupsNavContainer.find('.nav-link').removeClass('active').removeClass('remove');
            groupsNavContainer.find('.nav-link[data-cid="' + this.selectedBidForm.cid + '"]').addClass('active show');

            this.selectedBidForm.fetch({
                success: _.bind(function () {
                    fnRender();
                }, this)
            });
        } else {
            fnRender();
        }
    },
    selectGroup: function (e) {
        let target = $(e.currentTarget);
        this.renderSubview(target.data('cid'));
    },
    selectProjectBidForm: function (e) {
        this.$('.bid-form-group').removeClass('active');
        let bidFormTarget = $(e.currentTarget).data('target');
        this.renderBidFormEditor();
        $('body').animate({
            scrollTop: $('.' + bidFormTarget).offset().top
        });
    },
    addBiddersSimple: function () {
        let showUnionStatus = true;
        if (PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.IS_HIDE_UNION_STATUS)) {
            showUnionStatus = !PJQ.app.session.preferences.getPref(PJQ.constants.preferenceTypes.IS_HIDE_UNION_STATUS);
        }
        new PJQ.views.projectParticipants.AddParticipantsModal({
            model: PJQ.app.session.project,
            isUnionStatusEnabled: showUnionStatus,
            isDirectoryEnabled: PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.ENABLE_DIRECTORY),
            onSave: _.bind(function () {
                this.collection.fetchReset();
            }, this)
        });
    },
    addBiddersFromContacts: function () {
        new PJQ.views.contacts.SelectContactsModal({
            context: PJQ.constants.contacts.contexts.CONTACTS,
            isSingleChoice: false,
            subtitle: "Add Participants From Address Book",
            onSave: _.bind(function (selectedContacts) {
                PJQ.app.session.project.addParticipantsById(selectedContacts, _.bind(function () {
                    this.collection.fetchReset();
                }, this));
            }, this)
        });
    },
    addTrades: function () {
        let endpoint;
        if (this.options.bidFormTemplate) {
            endpoint = PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'bidforms'
                },
                {
                    endpoint: 'templates',
                    value: this.options.bidFormTemplate.id
                },
                {
                    endpoint: 'bidforms'
                }
            ]);
            if (this.options.bidFormTemplate.get('bidPackageTemplateId')) {
                new PJQ.views.bidPackages.EditTemplateModal({
                    templateId: this.options.bidFormTemplate.get('bidPackageTemplateId'),
                    onClose: _.bind(function () {
                        this.renderBidFormsSummary();
                        this.renderGroupBidForms()
                    }, this)
                });
            } else {
                new PJQ.views.groups.SelectGroupsModal({
                    selectorOptions: {
                        disabledGroupIds: _.uniq(_.map(this.collection.models, function (bidForm) {
                            return bidForm.get('groupId');
                        }))
                    },
                    onSave: _.bind(function (groups) {
                        new PJQ.ajax.Request({
                            endpoint: endpoint,
                            data: {
                                groupIds: _.map(groups.new, function (group) {
                                    return group.id;
                                })
                            }
                        }).post().done(_.bind(function () {
                            if (this.options.bidFormTemplate != null) {
                                this.options.bidFormTemplate.fetch({
                                    success: _.bind(function () {
                                        this.collection = this.options.bidFormTemplate.groupBidForms;
                                        this.collection.isFetched = true;
                                        this.render();
                                    }, this)
                                })
                            } else {
                                this.collection.fetchReset();
                            }
                        }, this));
                    }, this)
                });
            }
        } else {
            endpoint = PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'projects',
                    value: this.options.project.id
                },
                {
                    endpoint: 'bidforms'
                }
            ]);

            if (this.options.settings.get('isUsingBidPackages') || (this.options.bidFormTemplate != null && this.options.bidFormTemplate.get('bidPackageTemplateId'))) {
                new PJQ.views.bidPackages.ManageBidPackagesModal({
                    project: this.options.project,
                    onClose: _.bind(function (data) {
                        if (data.changed) {
                            this.collection.fetch({
                                success: _.bind(function () {
                                    this.render();
                                }, this)
                            })
                        }
                    }, this)
                })
            } else if (this.options.project) {
                let bidPackages = new PJQ.collections.bidPackages.BidPackages(null, {
                        projectId: this.options.project ? this.options.project.id : null
                    }),
                    fnSelectGroups = _.bind(function () {
                        new PJQ.views.groups.SelectGroupsModal({
                            selectorOptions: {
                                disabledGroupIds: _.uniq(_.map(this.collection.models, function (bidForm) {
                                    return bidForm.get('groupId');
                                }))
                            },
                            onSave: _.bind(function (groups) {
                                new PJQ.ajax.Request({
                                    endpoint: endpoint,
                                    data: {
                                        groupIds: _.map(groups.new, function (group) {
                                            return group.id;
                                        })
                                    }
                                }).post().done(_.bind(function () {
                                    if (this.options.bidFormTemplate != null) {
                                        this.options.bidFormTemplate.fetch({
                                            success: _.bind(function () {
                                                this.collection = this.options.bidFormTemplate.groupBidForms;
                                                this.collection.isFetched = true;
                                                this.render();
                                            }, this)
                                        })
                                    } else {
                                        this.collection.fetchReset();
                                    }
                                }, this));
                            }, this)
                        });
                    }, this);
                bidPackages.fetch({
                    success: _.bind(function (collection) {
                        if (_.size(collection.models) > 0) {
                            new PJQ.views.modals.YesNo({
                                header: "Bid Packages Exist",
                                body: "Bid Packages currently exist on this project. Would you like to use bid packages on bid forms instead of individual trades?",
                                onYes: _.bind(function () {
                                    let settings = this.options.settings;
                                    settings.set('isUsingBidPackages', true);
                                    settings.save();
                                    new PJQ.views.bidPackages.ManageBidPackagesModal({
                                        project: this.options.project,
                                        onClose: _.bind(function () {
                                            this.collection.fetch({
                                                success: _.bind(function () {
                                                    this.render();
                                                }, this)
                                            });
                                        }, this)
                                    })
                                }, this),
                                onNo: _.bind(function () {
                                    fnSelectGroups();
                                }, this),
                            });
                        } else {
                            fnSelectGroups();
                        }
                    }, this)
                });
            } else {
                fnSelectGroups();
            }
        }
    },
    addBiddersFromProject: function () {
        new PJQ.views.projectParticipants.AddParticipantsFromProjectModal({
            model: PJQ.app.session.project,
            isBidFormsEnabled: PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.ENABLE_BID_FORMS),
            onSave: _.bind(function () {
                this.collection.fetchReset();
            }, this)
        });
    },
    newContact: function () {
        new PJQ.views.contacts.BaseEditContactModal({
            model: new PJQ.models.projectParticipants.ProjectParticipant({
                projectId: PJQ.app.session.project.id,
                country: PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.ADDRESS_BOOK_DEFAULT_COUNTRY) ? PJQ.app.session.preferences.getPref(PJQ.constants.preferenceTypes.ADDRESS_BOOK_DEFAULT_COUNTRY) : 'US'
            }),
            onSave: _.bind(function () {
                this.collection.fetchReset();
            }, this)
        });
    },
    exportBidForms: function () {
        PJQ.files.queueDownload(PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'projects',
                value: PJQ.app.session.project.id
            },
            {
                endpoint: 'proposals'
            },
            {
                endpoint: 'export'
            }
        ]));
    },
    viewSettings: function () {
        new PJQ.views.bidForms.BidFormSettingsModal({
            project: this.options.project,
            model: this.options.settings,
            onSave: _.bind(function () {
                this.collection.fetch({
                    success: _.bind(function () {
                        this.render();
                    }, this)
                });
            }, this)
        });
    },
    saveAsTemplate: function () {
        new PJQ.views.bidForms.SaveAsTemplateModal({
            project: PJQ.app.session.project
        });
    },
    importTemplate: function () {
        new PJQ.views.bidForms.ImportTemplateModal({
            project: PJQ.app.session.project,
            onImport: _.bind(function (bidForm, settings) {
                if (settings != null) {
                    this.options.settings = settings;
                }
                this.collection.fetch({
                    success: _.bind(function () {
                        this.render();
                    }, this),
                    error: _.bind(function () {
                        this.render();
                    }, this)
                });
            }, this)
        });
    },
    sealBids: function() {
        this.options.project.fetchProjectContacts(_.bind(function(result) {
            let projectContacts = _.filter(result.models, function(contact) {
                return contact.get('id') < 0;
            });

            if (_.size(projectContacts) == 0 && !this.options.settings.get('isSealBids')) {
                new PJQ.views.BaseModal({
                    header: "Cannot Seal Bids",
                    body: "Please assign Company Users to Project Contacts before sealing bids for this project."
                });
            } else {
                new PJQ.views.bidForms.SealedBidContactsModal({
                    projectContacts: new PJQ.collections.projectContacts.ProjectContacts(projectContacts),
                    selectedProjectContacts: null,
                    isEdit: !this.options.settings.get('isSealBids'),
                    onSealBids: _.bind(function(contacts) {
                        this.options.settings.set('isSealBids', true);
                        this.options.settings.set('sealedBidContactList', contacts);
                        this.options.settings.save({},{
                            success: _.bind(function() {
                                this.render();
                                PJQ.notifications.notify.successNotify({
                                    message: 'Bids sealed for project.'
                                });
                            }, this)
                        });
                    }, this)
                });
            }
        }, this));
    },
    viewSealedBidContacts: function() {
        new PJQ.views.bidForms.SealedBidContactsModal({
            projectContacts: null,
            selectedProjectContacts: new PJQ.collections.projectContacts.ProjectContacts(this.options.settings.get('sealedBidContactList')),
            isEdit: false
        });
    },
    unsealBids: function() {
        new PJQ.views.modals.YesNo({
            header: "Unseal Bids",
            body: "Are you sure you want to unseal bids for this project?",
            onYes: _.bind(function () {
                this.options.settings.set('isSealBids', false);
                this.options.settings.set('sealedBidContactList', []);
                this.options.settings.save({},{
                    success: _.bind(function() {
                        this.render();
                        PJQ.notifications.notify.successNotify({
                            message: 'Bids unsealed for project.'
                        });
                    }, this)
                });
            }, this)
        });

    }
});

PJQ.views.bidForms.BidFormsSummary = PJQ.views.BaseView.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.BIDFORMS, 'Bid-Forms-Summary'),
        onViewBidForm: null,
        onDeleteBidForm: null
    },
    events: {
        'click .btn-view-bid-form': 'viewBidFormClicked',
        'click .btn-view-participants': 'viewParticipantsClicked',
        'click .btn-view-proposals': 'viewProposalsClicked',
        'change .select-all-groups': 'selectAllGroups',
        'change .select-group': 'selectGroup',
        'click .btn-export-all': 'exportAll',
        'click .btn-export-select': 'startExport',
        'click .btn-export-selected': 'exportSelected',
        'click .btn-cancel-export': 'cancelExport',
        'click .btn-bid-form-delete': 'deleteBidForm',
        'click .btn-cancel-delete': 'cancelDelete',
        'click .btn-delete-select': 'startDelete',
        'click .btn-delete-selected': 'deleteSelected'
    },
    deleteBidForm: function (e) {
        let bidForm = this.dataTable.getRow($(e.currentTarget)).data();

        let body = "Are you sure you want to delete this bid form?<br /><br /><strong>Note:</strong> All proposals for this bid form will be deleted.  This groups will also be removed from all participants on this project.  Participants who are only in this group will be removed from the project.";
        if (this.options.settings.get('isUsingBidPackages'))
            body = "Are you sure you want to delete this bid package?<br /><br /><strong>Note:</strong> All line items and proposals for this bid package will be deleted.   The bid package will still appear in the summary after being deleted.  To remove it permanently, click Manage Bid Packages.";

        if (bidForm != null) {
            new PJQ.views.modals.DeleteCancel({
                header: "Confirm Deletion",
                body: body,
                onDelete: _.bind(function () {
                    let groupName = '',
                        row = this.dataTable.getRow(bidForm.cid);
                    if (bidForm.get('group') != null) {
                        groupName = bidForm.get('group').groupName;
                    } else if (bidForm.get('bidPackage') != null) {
                        groupName = bidForm.get('bidPackage').name;
                    }

                    if (!this.options.settings.get('isUsingBidPackages'))
                        this.collection.remove(bidForm);

                    bidForm.destroy( {
                        success: _.bind(function() {
                            if (row != null && !this.options.settings.get('isUsingBidPackages')) {
                                this.dataTable.removeRow(row);
                            }

                            PJQ.notifications.notify.successNotify({
                                message: groupName + ' bid form deleted'
                            });

                            if (typeof this.options.onDeleteBidForm === 'function') {
                                this.options.onDeleteBidForm(bidForm);
                            }
                            this.render();
                        }, this)
                    });
                }, this)
            });
        }
    },
    beforeFirstRender: function () {
        this.options.canEdit = this.options.project != null ? this.options.project.hasPermission('bidForms.isAdmin') : true;
    },
    afterRender: function () {
        this.selectedGroupIds = [];

        let groupColumn;
        if (this.collection.models.length > 0 && this.collection.models[0].get('bidPackage')) {
            groupColumn = {
                data: "attributes.bidPackage",
                title: "Bid Package",
                "render": function (data) {
                    return data.name;
                }
            }
        } else {
            groupColumn = {
                data: "attributes.group",
                title: "Trade",
                "render": function (data) {
                    return data.groupName;
                }
            }
        }
        let managedByColumn = {
                data: "attributes.managedBy",
                title: "Managed By",
                render: function (data, type, row) {
                    let result = '';
                    if (row.managedBy != null) {
                        return PJQ.helpers.contacts.getContactAnchor({contact: row.managedBy});
                    } else {
                        result = 'Nobody';
                    }
                    return result;
                }
            },
            estimateColumn = {
                data: "attributes.estimate",
                title: "Estimate",
                render: function (data, type, row) {
                    let result = '';
                    if (row.get('estimate') != null) {
                        return PJQ.helpers.formatHelpers.formatCurrency(row.get('estimate'));
                    } else {
                        result = '-';
                    }
                    return result;
                }
            },
            editColumn = {
                data: "attributes.bidFormId",
                title: "",
                width: '80px',
                orderable: false,
                searchable: false,
                className: 'text-align-center',
                render: _.bind(function () {
                    if (this.options.isExport || this.options.isDelete)
                        return '';

                    let result = '<div class="show-on-row-hover"><button type="button" class="btn btn-info btn-view-bid-form"><i class="fal fa-eye"></i></button>';
                    if (this.options.canEdit && !this.options.settings.get('isSealBids')) {
                        result += '<button type="button" class="btn btn-danger btn-bid-form-delete ml-1"><span class="fal fa-trash"></span></button>'
                    }
                    result += '</div>';

                    return result;
                }, this)
            };
        let columns = [];
        if (this.options.isExport || this.options.isDelete) {
            columns.push({
                "columnData": 'selectGroup',
                "title": '<div class="pretty p-default"><input type="checkbox" class="select-all-groups" /><div class="state p-primary"><label class="wd-0">&nbsp;</label></div></div>',
                "width": "20px",
                "data": "null",
                "orderable": false,
                "searchable": false,
                "render": _.bind(function (data, type, row) {
                    let isSelected = this.selectedGroupIds.indexOf(row.get('groupId')) !== -1 || this.selectedGroupIds.indexOf(-row.get('bidPackageId')) !== -1;
                    return '<div class="pretty p-default"><input type="checkbox" ' + (isSelected ? 'checked' : '') + ' data-group-id="' + row.get('groupId') + '" data-bid-package-id="' + row.get('bidPackageId') + '" class="select-group" /><div class="state p-primary"><label class="wd-0">&nbsp;</label></div></div>';
                }, this)
            });
        }
        if (this.options.project != null) {
            columns.push(...[
                groupColumn,
                managedByColumn,
                {
                    "data": "attributes.dueDate",
                    "title": "Bids Due",
                    "searchable": false,
                    "width": '150px',
                    "render":
                        function (data) {
                            if (data != null) {
                                let dueDate = new Date(data);
                                return PJQ.helpers.dateHelpers.getDateString(dueDate, PJQ.helpers.dateHelpers.dateFormats.DATE_TIME);
                            }
                            return 'Not Set';
                        }
                },
                {
                    "data": "attributes.biddersCount",
                    "title": "Participants",
                    "searchable": false,
                    "render":
                        function (data) {
                            let result;
                            if (data) {
                                result = '<a href="javascript:void(0)" class="btn-view-participants">' + data.toString() + '</a>';
                            } else {
                                result = '-';
                            }
                            return result;
                        }
                },
                {
                    "data": "attributes.submittedProposalsCount",
                    "title": "Proposals",
                    "searchable": false,
                    "render":
                        function (data) {
                            let result;
                            if (data) {
                                result = '<a href="javascript:void(0)" class="btn-view-proposals">' + data.toString() + '</a>';
                            } else {
                                result = '-';
                            }
                            return result;
                        }
                },
                estimateColumn
            ]);

            if (!this.options.settings.get('isHideTotal')) {
                columns.push(...[
                    {
                        data: "attributes.lowestProposalTotal",
                        title: "Apparent Low",
                        render: function (data) {
                            let result;
                            if (data) {
                                return PJQ.helpers.formatHelpers.formatCurrency(data);
                            } else {
                                result = '-';
                            }
                            return result;
                        }
                    },
                    {
                        data: "attributes.awardedProposalTotal",
                        title: "Awarded",
                        render: function (data) {
                            let result;
                            if (data) {
                                return PJQ.helpers.formatHelpers.formatCurrency(data);
                            } else {
                                result = '-';
                            }
                            return result;
                        }
                    }
                ]);
            }

            columns.push(editColumn);
        } else {
            columns.push(...[
                groupColumn,
                estimateColumn,
                editColumn
            ]);
        }

        this.dataTable = new PJQ.views.dataTables.DataTable({
            el: this.$('.bid-forms-summary'),
            rowId: "cid",
            data: _.sortBy(this.collection.models, _.bind(function(model) {
                if (this.options.settings.get('isUsingBidPackages') || (this.options.bidFormTemplate != null && this.options.bidFormTemplate.get('bidPackageTemplateId'))) {
                    return model.get('bidPackage').name;
                } else {
                    return model.get('group').groupName;
                }
            }, this)),
            order: [[(this.options.isExport ? 1 : 0), "asc"]],
            paging: false,
            deferRender: true,
            onRowDoubleClick: _.bind(function (row) {
                this.viewBidForm(row.data());
            }, this),
            subTemplates: {
                header: new PJQ.templating.Template(PJQ.constants.modules.BIDFORMS, 'data-table-header-bid-forms-summary')
            },
            headerData: _.bind(function () {
                return {
                    isExport: this.options.isExport,
                    canExport: !this.options.settings.get('isSealBids') || this.options.settings.isSealedBidContact(PJQ.app.session.user.get('id')),
                    collection: this.collection,
                    isUsingBidPackages: this.options.settings.get('isUsingBidPackages'),
                    canDelete: this.options.canEdit && !this.options.settings.get('isSealBids'),
                    isDelete: this.options.isDelete
                };
            }, this),
            contextMenuOptions: {
                actions: [
                    {
                        name: 'View Proposals',
                        onClick: _.bind(function (row) {
                            this.viewBidForm(row.data(), 'PROPOSALS');
                        }, this)
                    }
                ]
            },
            columns: columns
        });
    },
    viewBidFormClicked: function (e) {
        let $target = $(e.currentTarget).closest('tr'),
            row = this.dataTable.getRow($target),
            bidForm = row.data();

        if (bidForm == null) {
            let parent = $($($(e.currentTarget)[0].parentElement)[0].parentElement)[0],
                row = this.dataTable.getRow(parent),
                bidForm = row.data();

            this.viewBidForm(bidForm);
        } else {
            this.viewBidForm(bidForm);
        }
    },
    viewParticipantsClicked: function (e) {
        this.viewBidForm(this.dataTable.getRow($(e.currentTarget)).data(), 'PARTICIPANTS');
    },
    viewProposalsClicked: function (e) {
        this.viewBidForm(this.dataTable.getRow($(e.currentTarget)).data(), 'PROPOSALS');
    },
    viewBidForm: function (bidForm, view = null) {
        if (this.options.onViewBidForm != null) {
            this.options.onViewBidForm(bidForm, view);
        }
    },
    selectGroup: function (e) {
        let $c = $(e.currentTarget),
            checked = $c.prop('checked'),
            groupId = parseInt($c.data('groupId')),
            bidPackageId = parseInt($c.data('bidPackageId')),
            value = groupId ? groupId : -bidPackageId;

        if (checked && this.selectedGroupIds.indexOf(value) === -1) {
            this.selectedGroupIds.push(value);
        } else {
            this.selectedGroupIds = _.without(this.selectedGroupIds, value);
        }
    },
    selectAllGroups: function (e) {
        let checked = $(e.currentTarget).prop('checked');
        if (checked) {
            this.selectedGroupIds = _.map(this.collection.models, function (model) {
                return model.get('groupId') ? model.get('groupId') : model.get('bidPackageId');
            });
        } else {
            this.selectedGroupIds = [];
        }
        this.$('.select-group').prop('checked', checked);
    },
    startDelete: function () {
        this.options.isDelete = true;
        this.render();
        this.$('.btn-export-dropdown').prop('disabled', true);
    },
    cancelDelete: function () {
        this.options.isDelete = false;
        this.render();
        this.$('.btn-export-dropdown').prop('disabled', false);
    },
    deleteSelected: function () {
        if (_.size(this.selectedGroupIds) == 0) {
            new PJQ.views.BaseModal({
                header: "No Selection",
                body: "Please select 1 or more " + (this.options.settings.get('isUsingBidPackages') ? 'Bid Packages' : 'Trades' ) + " to delete."
            });
            return;
        }

        let body = "Are you sure you want to delete " + _.size(this.selectedGroupIds) + " bid forms?<br /><br /><strong>Note:</strong> All proposals for these bid forms will be deleted.  The groups will also be removed from all participants on this project.  Participants who are only in these groups will be removed from the project.";
        if (this.options.settings.get('isUsingBidPackages'))
            body = "Are you sure you want to delete " + _.size(this.selectedGroupIds) + " bid packages?<br /><br /><strong>Note:</strong> All line items and proposals for these bid packages will be deleted.   The bid packages will still appear in the summary after being deleted.  To remove them permanently, click Manage Bid Packages.";

        new PJQ.views.modals.DeleteCancel({
            header: "Confirm Deletion",
            body: body,
            onDelete: _.bind(function () {

                this.collection.deleteList(this.selectedGroupIds, _.bind(function() {
                    this.selectedGroupIds = [];
                    this.options.isDelete = false;
                    PJQ.notifications.notify.successNotify({
                        message: 'Bid Forms deleted successfully'
                    });
                    if (typeof this.options.onDeleteBidForms === 'function') {
                        this.options.onDeleteBidForms();
                    }
                    this.render();
                }, this));

            }, this)
        });
    },
    startExport: function () {
        this.options.isExport = true;
        this.render();
        this.$('.btn-delete-select').prop('disabled', true);
    },
    cancelExport: function () {
        this.options.isExport = false;
        this.render();
        this.$('.btn-delete-select').prop('disabled', false);
    },
    exportSelected: function () {
        if (_.size(this.selectedGroupIds) == 0) {
            new PJQ.views.BaseModal({
                header: "No Selection",
                body: "Please select 1 or more " + (this.options.settings.get('isUsingBidPackages') ? 'Bid Packages' : 'Trades' ) + " to export."
            });
            return;
        }

        this.collection.export(this.selectedGroupIds);
        this.selectedGroupIds = [];
        this.options.isExport = false;
        this.render();
        this.$('.btn-delete-select').prop('disabled', false);
    },
    exportAll: function () {
        this.collection.export();
    }
});

PJQ.views.bidForms.BidFormEditorContainer = PJQ.views.BaseView.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.BIDFORMS, 'Editor-Container')
    },
    events: {
        'click .btn-edit-managed-by': 'editManagedBy',
        'click .btn-edit-bid-package-attachments': 'editAttachments',
        'click .btn-edit-bid-package-attachments-tags': 'editAttachmentsTags',
        'click .btn-view-drawing': 'viewDrawing'
    },
    beforeFirstRender: function () {
        this.options.canEdit = this.options.project != null ? this.options.project.hasPermission('bidForms.isAdmin') : true;

        if (this.model) {
            this.listenTo(this.model.bidders, 'sync change reset', this.renderTabCounts);
            this.listenTo(this.model.managedBy, 'sync change reset', this.renderManagedBy);
        }

        if (this.options.projectBidForm)
            this.projectBidForm = this.options.projectBidForm;
        if (this.options.project) {
            this.options.project.fetchVersions(_.bind(function (versions) {
                this.versions = versions;
                this.render();
            }, this));
        } else {
            this.render();
        }
    },
    renderData: function () {
        return {
            project: this.options.project,
            canEdit: this.options.canEdit,
            model: this.model,
            activeView: this.options.activeView,
            bidPackageAttachments: this.getBidPackageAttachments()
        };
    },
    afterRender: function () {
        if (this.options.canEdit && (this.versions == null || !this.versions.isFetched) && this.options.project) {
            return;
        }

        //this.options.activeView = null;

        this.editor = new PJQ.views.bidForms.BidFormEditor({
            el: this.$('#bidFormContainer'),
            project: this.options.project,
            canEdit: this.options.canEdit,
            settings: this.options.settings,
            model: this.model,
            projectBidForm: this.projectBidForm,
            collection: this.options.collection
        });

        if (this.model) {
            if (this.model.get('projectId') > 0) {
                new PJQ.inputs.DateEditorInput({
                    el: this.$('.bid-form-group-due-date'),
                    canEdit: this.options.canEdit,
                    value: this.model.getDueDate(),
                    label: "Bids Due",
                    nullText: "TBD",
                    extraLabelClasses: "text-dark font-weight-light",
                    onSave: _.bind(function (newValue) {
                        this.model.set('dueDate', newValue);
                        this.model.save();
                    }, this)
                });

                if (PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.ENABLE_BID_PACKAGES)) {
                    if (this.model.bidPackage != null) {
                        if (PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.ENABLE_BID_PACKAGES_COUNT)) {
                            new PJQ.inputs.TextAreaEditorInput({
                                el: this.$('.bid-form-bid-package-notes'),
                                canEdit: this.options.canEdit,
                                value: this.model.bidPackage.get('notes'),
                                label: "Notes",
                                nullText: "test",
                                extraLabelClasses: "text-dark font-weight-light",
                                onSave: _.bind(function (newValue) {
                                    this.model.bidPackage.set('notes', newValue);
                                    this.model.bidPackage.patch();
                                }, this)
                            })

                            new PJQ.inputs.Selectpicker({
                                el: this.$('.select-bid-package-count'),
                                defaultValue: this.model.bidPackage.get('count'),
                                onChange: _.bind(function (value) {
                                    this.model.bidPackage.set('count', value);
                                    this.model.bidPackage.patch();
                                }, this)
                            });
                        }
                    }
                }

                new PJQ.inputs.CurrencyEditorInput({
                    el: this.$('.bid-form-estimate'),
                    canEdit: this.options.canEdit,
                    value: this.model.get('estimate'),
                    onSave: _.bind(function (newValue) {
                        this.model.patch({
                            estimate: newValue
                        });
                        this.options.activeView = this.getActiveView();
                        this.render();
                    }, this)
                });

                if (PJQ.app.options.initProposal != null && !PJQ.app.options.initProposal.get('isShown')) {
                    this.$('#bidformProposalsTab').tab('show');
                    this.options.initProposal = null;
                }

                new PJQ.views.bidForms.Proposals({
                    el: this.$('#proposalsContainer'),
                    project: this.options.project,
                    collection: this.model.bidders,
                    bidForm: this.model,
                    settings: this.options.settings
                });

                new PJQ.views.bidForms.Bidders({
                    el: this.$('#biddersContainer'),
                    settings: this.options.settings,
                    project: this.options.project,
                    collection: this.model.bidders,
                    bidFormId: this.model.id
                });

                this.renderTabCounts();
            }
        }
    },
    getBidPackageAttachments: function () {
        let drawingIds,
            entryIds,
            tags;
        if (this.model.bidPackage != null) {
            drawingIds = _.map(_.filter(this.model.bidPackage.attachments.models, function (att) {
                return att.get('drawingId') > 0;
            }), function (att) {
                return att.get('drawingId');
            });

            entryIds = _.map(_.filter(this.model.bidPackage.attachments.models, function (att) {
                return att.get('entryId') > 0;
            }), function (att) {
                return att.get('entryId');
            });

            tags = _.map(_.filter(this.model.bidPackage.attachments.models, function (att) {
                return _.size(att.get('drawingTagName')) > 0;
            }), function (att) {
                return att.get('drawingTagName');
            });
        } else {
            drawingIds = [];
            entryIds = [];
            tags = [];
        }

        return {
            drawingIds: drawingIds,
            entryIds: entryIds,
            tags: tags
        }
    },
    viewDrawing: function (e) {
        let drawingId = parseInt($(e.currentTarget).data('drawingId')),
            version = null,
            drawing = null;
        _.each(this.versions.models, function (ver) {
            _.each(ver.drawings.models, function (dr) {
                if ((drawing == null || ver.id === -1) && dr.id === drawingId) {
                    version = ver;
                    drawing = dr;
                }
            }, this);
        }, this);
        if (version != null && drawing != null) {
            new PJQ.views.drawings.DrawingViewer({
                model: drawing,
                contextVersion: version,
                versions: this.versions
            });
        }
    },
    afterSync: function () {
        this.renderTabCounts();
        this.renderManagedBy();
    },
    renderTabCounts: function () {
        this.$('.badge-bidders').html(this.model.bidders.models.length);
        if (this.model.get('bidPackage') != null) {
            this.$('.badge-proposals').html(this.model.bidders.getProposalCount(null));
        } else {
            this.$('.badge-proposals').html(this.model.bidders.getProposalCount(this.model.id));
        }
    },
    renderManagedBy: function () {
        if (this.model.managedBy != null && this.model.managedBy.id !== 0) {
            this.$('.bid-form-managed-by-contact-name').find('.watch-contact-edit').text(this.model.managedBy.get('contactName')).data('contactId', this.model.managedBy.id);
        }
    },
    getActiveView: function () {
        switch ($('.tab-pane.active').attr('id')) {
            case 'biddersContainer':
                return 'PARTICIPANTS';
            case 'proposalsContainer':
                return 'PROPOSALS';
            default:
                return 'BIDFORM';
        }
    },
    editManagedBy: function () {
        new PJQ.views.contacts.SelectContactsModal({
            context: PJQ.constants.contacts.contexts.USERS,
            hideContacts: this.model.managedBy,
            onSave: _.bind(function (contact) {
                this.model.managedBy = contact;
                this.renderManagedBy();
                this.model.save();
            }, this)
        });
    },
    editAttachments: function () {
        let selectedAttachments = this.getBidPackageAttachments();
        new PJQ.views.files.FileSelector({
            project: this.options.project,
            mode: 'SHARED',
            selectedEntryIds: selectedAttachments.entryIds,
            selectedDrawingIds: selectedAttachments.drawingIds,
            onSave: _.bind(function (attachments) {
                let entryIds = [],
                    drawingIds = [];
                _.each(attachments, function (attachment) {
                    if (attachment.get('entryId') > 0) {
                        entryIds.push(attachment.get('entryId'));
                    } else if (attachment.get('drawingId') > 0) {
                        drawingIds.push(attachment.get('drawingId'));
                    }
                })
                this.model.bidPackage.addAttachments(entryIds, drawingIds, selectedAttachments.tags, _.bind(function (attachments) {
                    this.render();
                }, this));
            }, this)
        });
    },
    editAttachmentsTags: function () {

    },
});

PJQ.views.bidForms.BidFormEditor = PJQ.views.BaseView.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.BIDFORMS, 'Editor-BidForm'),
        subTemplates: {
            lineItems: new PJQ.templating.Template(PJQ.constants.modules.BIDFORMS, 'editor-group-lineitems'),
            lineItem: new PJQ.templating.Template(PJQ.constants.modules.BIDFORMS, 'Editor-Group-LineItem'),
            alternate: new PJQ.templating.Template(PJQ.constants.modules.BIDFORMS, 'Editor-Group-Alternate'),
            groupAcknowledgement: new PJQ.templating.Template(PJQ.constants.modules.BIDFORMS, 'Editor-Group-Acknowledgement'),
            projectAcknowledgement: new PJQ.templating.Template(PJQ.constants.modules.BIDFORMS, 'Editor-Project-Acknowledgement'),
            bonding: new PJQ.templating.Template(PJQ.constants.modules.BIDFORMS, 'Editor-Project-Bonding'),
            certification: new PJQ.templating.Template(PJQ.constants.modules.BIDFORMS, 'Editor-Project-Certification'),
            laborRate: new PJQ.templating.Template(PJQ.constants.modules.BIDFORMS, 'Editor-Project-Labor-Rate')
        },
        isEdit: false
    },
    events: {
        "click .bid-form-edit": "enableEdit",
        "click .bid-form-edit-cancel": "cancelEdit",
        "click .bid-form-save": "saveBidForm",
        "click .bid-form-preview": "previewBidForm",
        "click .add-group-line-item-button": "newGroupLineItem",
        "change .group-line-item-description,.group-line-item-category,.group-line-item-type,.group-line-item-default,.group-line-item-required,.group-line-item-readonly": "groupLineItemChanged",
        "click .delete-group-line-item-button": "deleteGroupLineItem",
        "click .add-group-alternate-button": "newGroupAlternate",
        "change .group-alternate-description,.group-alternate-category,.group-alternate-type,.group-alternate-default,.group-alternate-required,.group-alternate-readonly": "groupAlternateChanged",
        "click .delete-group-alternate-button": "deleteGroupAlternate",
        "click .add-group-acknowledgement-button": "newGroupAcknowledgement",
        "change .group-acknowledgement-description,.group-acknowledgement-category,.group-acknowledgement-type,.group-acknowledgement-required": "groupAcknowledgementChanged",
        "click .delete-group-acknowledgement-button": "deleteGroupAcknowledgement",
        "click .add-group-acknowledgement-choices-button": "addGroupAcknowledgementChoices",
        "click .add-project-acknowledgement-choices-button": "addProjectAcknowledgementChoices",
        "click .add-project-bonding-choices-button": "addProjectBondingChoices",
        "click .add-project-certification-choices-button": "addProjectCertificationChoices",
        "click .add-project-labor-rate-choices-button": "addProjectLaborRateChoices",
        "click .add-project-acknowledgement-button": "newProjectAcknowledgement",
        "change .project-acknowledgement-description,.project-acknowledgement-category,.project-acknowledgement-type,.project-acknowledgement-required": "projectAcknowledgementChanged",
        "click .delete-project-acknowledgement-button": "deleteProjectAcknowledgement",
        "click .add-project-bonding-button": "newProjectBonding",
        "change .project-bonding-description,.project-bonding-type,.project-bonding-required": "projectBondingChanged",
        "click .delete-project-bonding-button": "deleteProjectBonding",
        "click .add-project-certification-button": "newProjectCertification",
        "change .project-certification-description,.project-certification-type,.project-certification-required": "projectCertificationChanged",
        "click .delete-project-certification-button": "deleteProjectCertification",
        "click .add-project-labor-rate-button": "newProjectLaborRate",
        "change .project-labor-rate-description,.project-labor-rate-type,.project-labor-rate-required": "projectLaborRateChanged",
        "click .delete-project-labor-rate-button": "deleteProjectLaborRate",
        "click .bid-form-group-edit-due-date": "editBidFormDueDate",
        "click .copy-from": "copyFromOtherBidForm"
    },
    beforeFirstRender: function () {
        this.options.canEdit = this.options.project != null ? (this.options.project.hasPermission('bidForms.isAdmin') && !this.options.settings.get('isSealBids')) : true;
        if (this.model) {
            this.listenTo(this.model, "sync", this.render);
            this.isLoaded = false;
            if (this.model.id > 0) {
                this.model.fetch({
                    success: _.bind(function () {
                        this.isLoaded = true;
                    }, this),
                    error: _.bind(function () {
                        this.isLoaded = true;
                    }, this)
                });
            }
        }
        if (this.options.projectBidForm) {
            this.projectBidForm = this.options.projectBidForm;
            this.listenTo(this.projectBidForm, "sync", this.render);
            if (this.projectBidForm.id > 0) {
                this.projectBidForm.fetch({
                    success: _.bind(function () {
                        this.isLoaded = true;
                    }, this),
                    error: _.bind(function () {
                        this.isLoaded = true;
                    }, this)
                });
            }
        }
    },
    beforeRender: function () {
        this.renderData = {
            model: this.model,
            canEdit: this.options.canEdit,
            projectBidForm: this.projectBidForm,
            dateHelpers: PJQ.helpers.dateHelpers,
            isEdit: this.options.isEdit
        };
    },
    afterRender: function () {
        if (this.model) {
            this.renderGroupLineItems();
            this.renderGroupAlternates();
            this.renderGroupAcknowledgements();

            this.otherBidForms = null;
            if (this.options.collection) {
                this.otherBidForms = _.filter(this.options.collection.models, _.bind(function(bidForm) {
                    if (bidForm.get('groupId') && this.model.get('groupId') && bidForm.get('groupId') === this.model.get('groupId'))
                        return false;

                    if (bidForm.get('bidPackageId') && this.model.get('bidPackageId') && bidForm.get('bidPackageId') === this.model.get('bidPackageId'))
                        return false;

                    /* line items aren't populated until the bidform is visited
                    if (_.size(bidForm.get('lineItems')) == 0)
                        return false;

                     */

                    return true;
                }, this));

                if (_.size(this.otherBidForms) === 0)
                    this.$('.copy-from').hide();

            } else {
                this.$('.copy-from').hide();
            }
        }
        if (this.projectBidForm) {
            this.renderProjectAcknowledgements();
            this.renderProjectBondings();
            this.renderProjectCertifications();
            this.renderProjectLaborRates();
        }

        if (!this.isLoaded) {
            this.loader = new PJQ.Loader(this.$el);
        } else if (this.loader) {
            this.loader.remove();
        }
    },
    copyFromOtherBidForm: function() {
        new PJQ.views.bidPackages.CopyBidFormModal({
            isBidPackage: !this.model.get('groupId'),
            otherBidForms: this.otherBidForms,
            onCopy: _.bind(function(bidForm, copyLineItems, copyAlternates, copyAcknowledgements) {
                if (copyLineItems) {
                    _.each(bidForm.lineItems.models, _.bind(function(lineItem) {
                        this.model.set('isChanged', true);

                        let newLineItem = new PJQ.models.bidForms.LineItem({
                            bidFormId: this.model.id,
                            isNew: true,
                            sortOrder: _.size(this.model.lineItems) + 1,
                            description: lineItem.get('description'),
                            category: lineItem.get('category'),
                            defaultValue: lineItem.get('defaultValue'),
                            isRequired: lineItem.get('isRequired'),
                            isReadOnly: lineItem.get('isReadOnly'),
                            type: lineItem.get('type')
                        });

                        this.model.lineItems.add(newLineItem);
                    }, this));

                    this.model.set('lineItems', this.model.lineItems);
                    this.renderGroupLineItems();
                }

                if (copyAlternates) {
                    _.each(bidForm.alternates.models, _.bind(function(alternate) {
                        this.model.set('isChanged', true);
                        let newAlternate = new PJQ.models.bidForms.Alternate({
                            bidFormId: this.model.id,
                            isNew: true,
                            sortOrder: _.size(this.model.alternates) + 1,
                            description: alternate.get('description'),
                            category: alternate.get('category'),
                            defaultValue: alternate.get('defaultValue'),
                            isRequired: alternate.get('isRequired'),
                            isReadOnly: alternate.get('isReadOnly'),
                            type: alternate.get('type')
                        });
                        this.model.alternates.add(newAlternate);
                    }, this));

                    this.model.set('alternates', this.model.alternates);
                    this.renderGroupAlternates();
                }

                if (copyAcknowledgements) {
                    _.each(bidForm.acknowledgements.models, _.bind(function(acknowledgement) {
                        this.model.set('isChanged', true);
                        let newAcknowledgement = new PJQ.models.bidForms.Acknowledgement({
                            bidFormId: this.model.id,
                            isNew: true,
                            sortOrder: _.size(this.model.acknowledgements) + 1,
                            description: acknowledgement.get('description'),
                            isRequired: acknowledgement.get('isRequired'),
                            type: acknowledgement.get('type')
                        });

                        if (acknowledgement.choices && acknowledgement.choices.models) {
                            newAcknowledgement.choices = new PJQ.collections.customFields.CustomFieldChoices();
                            _.each(acknowledgement.choices.models, _.bind(function(choice) {
                                newAcknowledgement.choices.add(new PJQ.models.customFields.CustomFieldChoice({
                                    value: choice.get('value'),
                                    sortOrder: choice.get('sortOrder'),
                                    isDeleted: choice.get('isDeleted')
                                }));
                            }, this));
                            newAcknowledgement.set('choices', newAcknowledgement.choices.models)
                        }

                        this.model.acknowledgements.add(newAcknowledgement);
                    },this));

                    this.model.set('acknowledgements', this.model.acknowledgements);
                    this.renderGroupAcknowledgements();
                }

                PJQ.notifications.notify.successNotify({
                    message: 'Items copied successfully'
                });
            }, this)
        });
    },
    previewBidForm: function () {
        this.model.preview(null, {
            projectBidForm: this.projectBidForm
        });
    },
    newGroupLineItem: function () {
        if (this.model)
            this.model.set('isChanged', true);
        let newLineItem = new PJQ.models.bidForms.LineItem({
            bidFormId: this.model.id,
            isNew: true,
            sortOrder: _.size(this.model.lineItems) + 1
        });
        this.model.lineItems.add(newLineItem);
        this.model.set('lineItems', this.model.lineItems);
        this.renderGroupLineItems();
    },
    // renderGroupLineItems: function () {
    //     let hasProposals = this.model.bidders.getProposals(this.model.id).length > 0,
    //         groupLineItems = this.model.lineItems.models,
    //         $gli = this.$('.bid-form-group-line-items'),
    //         self = this;
    //     $gli.empty();
    //     let categories = _.uniq(_.map(groupLineItems, function (item) {
    //             let category = item.get('category');
    //             return category != null ? category : '';
    //         })),
    //         data = {
    //             lineItems: groupLineItems,
    //             categories: categories,
    //             isEdit: this.options.isEdit,
    //             hasProposals: hasProposals
    //         };
    //     this.renderSubTemplate(true, this.options.subTemplates.lineItems, this.$('.bid-form-group-line-items'), data, _.bind(function (content) {
    //         // if (lineItem.get('isNew'))
    //         // 	content.find('.group-line-item-description').focus();
    //         if (this.options.isEdit) {
    //             new PJQ.Sortable($gli, {
    //                 items: '.group-line-item-row',
    //                 connectWith: '.group-line-item-row',
    //                 multiple: true,
    //                 handle: '.group-line-item-sort',
    //                 onStop: function () {
    //                     self.setGroupLineItemSort();
    //                 }
    //             });
    //         }
    //     }, this));
    // },
    renderGroupLineItems: function () {
        let hasProposals = this.model.bidders.getProposals(this.model.id).length > 0,
            groupLineItems = this.model.lineItems.models,
            $gli = this.$('.bid-form-group-line-items'),
            self = this;
        $gli.empty();
        _.each(_.sortBy(_.sortBy(groupLineItems, function (groupLineItem) {
            return groupLineItem.get('sortOrder');
        }), function (groupLineItem) {
            return groupLineItem.get('contactCompanyId');
        }), function (groupLineItem) {
            self.renderGroupLineItem(groupLineItem, hasProposals);
        });
        if (this.options.isEdit) {
            new PJQ.Sortable($gli, {
                items: '.group-line-item-row',
                connectWith: '.group-line-item-row',
                multiple: true,
                handle: '.group-line-item-sort',
                onStop: function () {
                    self.setGroupLineItemSort();
                }
            });

            if(_.size(groupLineItems) > 0) {
                new PJQ.inputs.AutocompleteInput({
                    el: this.$('.group-line-item-category'),
                    source: _.bind(function (req, res) {
                        if (_.size(req.term) === 0) {
                            return [];
                        }
                        res(_.filter(_.map(groupLineItems, function (item) {
                            return item.get('category')
                        }), function (category) {
                            if (_.size(category) > 0 && category.toLowerCase().indexOf(req.term.toLowerCase()) !== -1) {
                                return category;
                            }
                        }));
                    }, this)
                });
            }

            PJQ.helpers.inputHelpers.inputMaskCurrency(this.$('.group-line-item-default'), 2);
        }
    },
    renderGroupLineItem: function (lineItem, hasProposals) {
        let data = {
            item: lineItem,
            isEdit: this.options.isEdit,
            hasProposals: hasProposals
        };
        this.renderSubTemplate(true, this.options.subTemplates.lineItem, this.$('.bid-form-group-line-items'), data, function (content) {
            if (lineItem.get('isNew'))
                content.find('.group-line-item-description').focus();
        });
    },
    setGroupLineItemSort: function () {
        let self = this;
        this.$('.group-line-item-row').each(function (index) {
            let cid = $(this).data('cid'),
                model = self.model.lineItems.get({cid: cid});
            model.set('sortOrder', index + 1);
        });
    },
    groupLineItemChanged: function (e) {
        let row = $(e.currentTarget).closest('.group-line-item-row'),
            cid = row.data('cid'),
            description = row.find('.group-line-item-description').val(),
            type = row.find('.group-line-item-type').val(),
            category = row.find('.group-line-item-category').val(),
            defaultValue = parseInt(PJQ.helpers.formatHelpers.numbersOnly(row.find('.group-line-item-default').val())),
            isRequired = row.find('.group-line-item-required').prop('checked'),
            isReadOnly = row.find('.group-line-item-readonly').prop('checked'),
            model = this.model.lineItems.get({cid: cid});

        model.set({
            description: description,
            category: category,
            defaultValue: defaultValue > 0 ? defaultValue : null,
            isRequired: isRequired,
            isReadOnly: isReadOnly,
        });
        if (model.get('type') !== type) {
            model.set('type', type);
            this.renderGroupLineItems();
        }
    },
    deleteGroupLineItem: function (e) {
        let cid = $(e.currentTarget).closest('.group-line-item-row').data('cid');
        this.model.updateLineItemDeleted(cid, true);
        $(e.currentTarget).closest('.group-line-item-row').remove();
    },
    newGroupAlternate: function () {
        if (this.model)
            this.model.set('isChanged', true);
        let newAlternate = new PJQ.models.bidForms.Alternate({
            bidFormId: this.model.id,
            isNew: true,
            sortOrder: _.size(this.model.alternates) + 1
        });
        this.model.alternates.add(newAlternate);
        this.model.set('alternates', this.model.alternates);
        this.renderGroupAlternates();
    },
    renderGroupAlternates: function () {
        let hasProposals = this.model.bidders.getProposals(this.model.id).length > 0,
            groupAlternates = this.model.alternates.models,
            $gal = this.$('.bid-form-group-alternates'),
            self = this;
        $gal.empty();
        _.each(_.sortBy(groupAlternates, function (groupAlternate) {
            return groupAlternate.get('sortOrder');
        }), function (groupAlternate) {
            self.renderGroupAlternate(groupAlternate, hasProposals);
        });
        if (this.options.isEdit) {
            new PJQ.Sortable($gal, {
                items: '.group-alternate-row',
                connectWith: '.group-alternate-row',
                multiple: true,
                handle: '.group-alternate-sort',
                onStop: function () {
                    self.setGroupAlternateSort();
                }
            });

            if(_.size(groupAlternates) > 0) {
                new PJQ.inputs.AutocompleteInput({
                    el: this.$('.group-alternate-category'),
                    source: _.bind(function (req, res) {
                        if (_.size(req.term) === 0) {
                            return [];
                        }
                        res(_.filter(_.map(groupAlternates, function (alternate) {
                            return alternate.get('category')
                        }), function (category) {
                            if (_.size(category) > 0 && category.toLowerCase().indexOf(req.term.toLowerCase()) !== -1) {
                                return category;
                            }
                        }));
                    }, this)
                });
            }

            PJQ.helpers.inputHelpers.inputMaskCurrency(this.$('.group-alternate-default'), 2);
        }
    },
    renderGroupAlternate: function (alternate, hasProposals) {
        let data = {
            item: alternate,
            isEdit: this.options.isEdit,
            hasProposals: hasProposals
        };
        this.renderSubTemplate(true, this.options.subTemplates.alternate, this.$('.bid-form-group-alternates'), data, function (content) {
            if (alternate.get('isNew'))
                content.find('.group-alternate-description').focus();
        });
    },
    setGroupAlternateSort: function () {
        let self = this;
        this.$('.group-alternate-row').each(function (index) {
            let cid = $(this).data('cid'),
                model = self.model.alternates.get({cid: cid});
            model.set('sortOrder', index + 1);
        });
    },
    groupAlternateChanged: function (e) {
        let row = $(e.currentTarget).closest('.group-alternate-row'),
            cid = row.data('cid'),
            description = row.find('.group-alternate-description').val(),
            category = row.find('.group-alternate-category').val(),
            type = row.find('.group-alternate-type').val(),
            defaultValue = parseInt(PJQ.helpers.formatHelpers.numbersOnly(row.find('.group-alternate-default').val())),
            isRequired = row.find('.group-alternate-required').prop('checked'),
            isReadOnly = row.find('.group-alternate-readonly').prop('checked'),
            model = this.model.alternates.get({cid: cid});

        model.set({
            description: description,
            category: category,
            defaultValue: defaultValue,
            isRequired: isRequired,
            isReadOnly: isReadOnly,
        });
        if (model.get('type') !== type) {
            model.set('type', type);
            this.renderGroupAlternates();
        }
    },
    deleteGroupAlternate: function (e) {
        let cid = $(e.currentTarget).closest('.group-alternate-row').data('cid');
        this.model.updateAlternateDeleted(cid, true);
        $(e.currentTarget).closest('.group-alternate-row').remove();
    },
    newGroupAcknowledgement: function () {
        if (this.model)
            this.model.set('isChanged', true);
        let newAcknowledgement = new PJQ.models.bidForms.Acknowledgement({
            bidFormId: this.model.id,
            isNew: true,
            sortOrder: _.size(this.model.acknowledgements) + 1
        });
        this.model.acknowledgements.add(newAcknowledgement);
        this.model.set('acknowledgements', this.model.acknowledgements);
        this.renderGroupAcknowledgement(newAcknowledgement);
    },
    renderGroupAcknowledgements: function () {
        let hasProposals = this.model.bidders.getProposals(this.model.id).length > 0,
            groupAcknowledgements = this.model.acknowledgements.models,
            $gak = this.$('.bid-form-group-acknowledgements'),
            self = this;
        $gak.empty();
        _.each(_.sortBy(groupAcknowledgements, function (groupAcknowledgement) {
            return groupAcknowledgement.get('sortOrder');
        }), function (groupAcknowledgement) {
            self.renderGroupAcknowledgement(groupAcknowledgement, hasProposals);
        });
        if (this.options.isEdit) {
            new PJQ.Sortable($gak, {
                items: '.group-acknowledgement-row',
                connectWith: '.group-acknowledgement-row',
                multiple: true,
                handle: '.group-acknowledgement-sort',
                onStop: function () {
                    self.setGroupAcknowledgementSort();
                }
            });
        }
    },
    renderGroupAcknowledgement: function (acknowledgement, hasProposals) {
        let data = {
            item: acknowledgement,
            isEdit: this.options.isEdit,
            acknowledgementTypes: PJQ.helpers.bidForms.acknowledgementTypes,
            hasProposals: hasProposals
        };
        this.renderSubTemplate(true, this.options.subTemplates.groupAcknowledgement, this.$('.bid-form-group-acknowledgements'), data, function (content) {
            if (acknowledgement.get('isNew'))
                content.find('.group-acknowledgement-description').focus();
        });
    },
    setGroupAcknowledgementSort: function () {
        let self = this;
        this.$('.group-acknowledgement-row').each(function (index) {
            let cid = $(this).data('cid'),
                model = self.model.acknowledgements.get({cid: cid});
            model.set('sortOrder', index + 1);
        });
    },
    groupAcknowledgementChanged: function (e) {
        let row = $(e.currentTarget).closest('.group-acknowledgement-row'),
            cid = row.data('cid'),
            description = row.find('.group-acknowledgement-description').val(),
            category = row.find('.group-acknowledgement-category').val(),
            type = row.find('.group-acknowledgement-type').val(),
            isRequired = row.find('.group-acknowledgement-required').prop('checked'),
            model = this.model.acknowledgements.get({cid: cid});

        model.set('description', description);
        model.set('category', category);
        if (model.get('type') !== type) {
            model.set('type', type);
            this.renderGroupAcknowledgements();
        }
        model.set('isRequired', isRequired);
    },
    deleteGroupAcknowledgement: function (e) {
        let cid = $(e.currentTarget).closest('.group-acknowledgement-row').data('cid');
        this.model.updateAcknowledgementDeleted(cid, true);
        $(e.currentTarget).closest('.group-acknowledgement-row').remove();
    },
    addGroupAcknowledgementChoices: function (e) {
        let cid = $(e.currentTarget).closest('.group-acknowledgement-row').data('cid'),
            model = this.model.acknowledgements.get({cid: cid});

        new PJQ.views.customFields.CustomFieldChoicesEditor({
            collection: model.choices,
            isHideSearch: true,
            onSave: _.bind(function (choices) {
                model.set('choices', choices.models);
            }, this)
        });
    },
    newProjectAcknowledgement: function () {
        this.projectBidForm.set('isChanged', true);
        let newAcknowledgement = new PJQ.models.bidForms.Acknowledgement({
            bidFormId: this.projectBidForm.id,
            isNew: true,
            sortOrder: _.size(this.projectBidForm.acknowledgements) + 1
        });
        this.projectBidForm.acknowledgements.add(newAcknowledgement);
        this.projectBidForm.set('acknowledgements', this.projectBidForm.acknowledgements);
        this.renderProjectAcknowledgement(newAcknowledgement);
    },
    renderProjectAcknowledgements: function () {
        let projectAcknowledgements = this.projectBidForm.acknowledgements.models,
            $gak = this.$('.bid-form-project-acknowledgements'),
            self = this;
        $gak.empty();
        _.each(_.sortBy(projectAcknowledgements, function (projectAcknowledgement) {
            return projectAcknowledgement.get('sortOrder');
        }), function (projectAcknowledgement) {
            self.renderProjectAcknowledgement(projectAcknowledgement);
        });
        if (this.options.isEdit) {
            new PJQ.Sortable($gak, {
                items: '.project-acknowledgement-row',
                connectWith: '.project-acknowledgement-row',
                multiple: true,
                handle: '.project-acknowledgement-sort',
                onStop: function () {
                    self.setProjectAcknowledgementSort();
                }
            });
        }
    },
    renderProjectAcknowledgement: function (acknowledgement) {
        let data = {
            item: acknowledgement,
            isEdit: this.options.isEdit,
            acknowledgementTypes: PJQ.helpers.bidForms.acknowledgementTypes
        };
        this.renderSubTemplate(true, this.options.subTemplates.projectAcknowledgement, this.$('.bid-form-project-acknowledgements'), data, function (content) {
            if (acknowledgement.get('isNew'))
                content.find('.project-acknowledgement-description').focus();
        });
    },
    setProjectAcknowledgementSort: function () {
        let self = this;
        this.$('.project-acknowledgement-row').each(function (index) {
            let cid = $(this).data('cid'),
                model = self.projectBidForm.acknowledgements.get({cid: cid});
            model.set('sortOrder', index + 1);
        });
    },
    projectAcknowledgementChanged: function (e) {
        let row = $(e.currentTarget).closest('.project-acknowledgement-row'),
            cid = row.data('cid'),
            description = row.find('.project-acknowledgement-description').val(),
            category = row.find('.project-acknowledgement-category').val(),
            type = row.find('.project-acknowledgement-type').val(),
            isRequired = row.find('.project-acknowledgement-required').prop('checked'),
            model = this.projectBidForm.acknowledgements.get({cid: cid});

        model.set('description', description);
        model.set('category', category);
        if (model.get('type') !== type) {
            model.set('type', type);
            this.renderProjectAcknowledgements();
        }
        model.set('isRequired', isRequired);
    },
    deleteProjectAcknowledgement: function (e) {
        let cid = $(e.currentTarget).closest('.project-acknowledgement-row').data('cid');
        this.projectBidForm.updateAcknowledgementDeleted(cid, true);
        $(e.currentTarget).closest('.project-acknowledgement-row').remove();
    },
    addProjectAcknowledgementChoices: function (e) {
        let cid = $(e.currentTarget).closest('.project-acknowledgement-row').data('cid'),
            model = this.projectBidForm.acknowledgements.get({cid: cid});

        new PJQ.views.customFields.CustomFieldChoicesEditor({
            collection: model.choices,
            isHideSearch: true,
            onSave: _.bind(function (choices) {
                model.set('choices', choices.models);
            }, this)
        });
    },
    newProjectBonding: function () {
        this.projectBidForm.set('isChanged', true);
        let newBonding = new PJQ.models.bidForms.Bonding({
            bidFormId: this.projectBidForm.id,
            isNew: true,
            sortOrder: _.size(this.projectBidForm.bonding) + 1
        })
        this.projectBidForm.bonding.add(newBonding);
        this.projectBidForm.set('bonding', this.projectBidForm.bonding);
        this.renderProjectBonding(newBonding);
    },
    renderProjectBondings: function () {
        let projectBonding = this.projectBidForm.bonding.models,
            $gak = this.$('.bid-form-project-bonding'),
            self = this;
        $gak.empty();
        _.each(_.sortBy(projectBonding, function (bond) {
            return bond.get('sortOrder');
        }), function (bond) {
            self.renderProjectBonding(bond);
        });
        if (this.options.isEdit) {
            new PJQ.Sortable($gak, {
                items: '.project-bonding-row',
                connectWith: '.project-bonding-row',
                multiple: true,
                handle: '.project-bonding-sort',
                onStop: function () {
                    self.setProjectBondingSort();
                }
            });
        }
    },
    renderProjectBonding: function (bonding) {
        let data = {
            item: bonding,
            isEdit: this.options.isEdit,
            bondingTypes: PJQ.helpers.bidForms.bondingTypes
        };
        this.renderSubTemplate(true, this.options.subTemplates.bonding, this.$('.bid-form-project-bonding'), data, function (content) {
            if (bonding.get('isNew'))
                content.find('.project-bonding-description').focus();
        });
    },
    setProjectBondingSort: function () {
        let self = this;
        this.$('.project-bonding-row').each(function (index) {
            let cid = $(this).data('cid'),
                model = self.projectBidForm.bonding.get({cid: cid});
            model.set('sortOrder', index + 1);
        });
    },
    projectBondingChanged: function (e) {
        let row = $(e.currentTarget).closest('.project-bonding-row'),
            cid = row.data('cid'),
            description = row.find('.project-bonding-description').val(),
            type = row.find('.project-bonding-type').val(),
            isRequired = row.find('.project-bonding-required').prop('checked'),
            model = this.projectBidForm.bonding.get({cid: cid});

        model.set('description', description);
        if (model.get('type') !== type) {
            model.set('type', type);
            this.renderProjectBondings();
        }
        model.set('isRequired', isRequired);
    },
    deleteProjectBonding: function (e) {
        let cid = $(e.currentTarget).closest('.project-bonding-row').data('cid');
        this.projectBidForm.updateBondingDeleted(cid, true);
        $(e.currentTarget).closest('.project-bonding-row').remove();
    },
    addProjectBondingChoices: function (e) {
        let cid = $(e.currentTarget).closest('.project-bonding-row').data('cid'),
            model = this.projectBidForm.bonding.get({cid: cid});

        new PJQ.views.customFields.CustomFieldChoicesEditor({
            collection: model.choices,
            isHideSearch: true,
            onSave: _.bind(function (choices) {
                model.set('choices', choices.models);
            }, this)
        });
    },
    newProjectCertification: function () {
        this.projectBidForm.set('isChanged', true);
        let newCertification = new PJQ.models.bidForms.Certification({
            bidFormId: this.projectBidForm.id,
            isNew: true,
            sortOrder: _.size(this.projectBidForm.certifications) + 1
        });
        this.projectBidForm.certifications.add(newCertification);
        this.projectBidForm.set('certifications', this.projectBidForm.certifications);
        this.renderProjectCertification(newCertification);
    },
    renderProjectCertifications: function () {
        let projectCertifications = this.projectBidForm.certifications.models,
            $gac = this.$('.bid-form-project-certifications'),
            self = this;
        $gac.empty();
        _.each(_.sortBy(projectCertifications, function (certification) {
            return certification.get('sortOrder');
        }), function (certification) {
            self.renderProjectCertification(certification);
        });
        if (this.options.isEdit) {
            new PJQ.Sortable($gac, {
                items: '.project-certification-row',
                connectWith: '.project-certification-row',
                multiple: true,
                handle: '.project-certification-sort',
                onStop: function () {
                    self.setProjectCertificationSort();
                }
            });
        }
    },
    renderProjectCertification: function (certification) {
        let data = {
            item: certification,
            isEdit: this.options.isEdit,
            certificationTypes: PJQ.helpers.bidForms.certificationTypes
        };
        this.renderSubTemplate(true, this.options.subTemplates.certification, this.$('.bid-form-project-certifications'), data, function (content) {
            if (certification.get('isNew'))
                content.find('.project-certification-description').focus();
        });
    },
    setProjectCertificationSort: function () {
        let self = this;
        this.$('.project-certification-row').each(function (index) {
            let cid = $(this).data('cid'),
                model = self.projectBidForm.certifications.get({cid: cid});
            model.set('sortOrder', index + 1);
        });
    },
    projectCertificationChanged: function (e) {
        let row = $(e.currentTarget).closest('.project-certification-row'),
            cid = row.data('cid'),
            description = row.find('.project-certification-description').val(),
            type = row.find('.project-certification-type').val(),
            isRequired = row.find('.project-certification-required').prop('checked'),
            model = this.projectBidForm.certifications.get({cid: cid});

        model.set('description', description);
        if (model.get('type') !== type) {
            model.set('type', type);
            this.renderProjectCertifications();
        }
        model.set('isRequired', isRequired);
    },
    deleteProjectCertification: function (e) {
        let cid = $(e.currentTarget).closest('.project-certification-row').data('cid');
        this.projectBidForm.updateCertificationDeleted(cid, true);
        $(e.currentTarget).closest('.project-certification-row').remove();
    },
    addProjectCertificationChoices: function (e) {
        let cid = $(e.currentTarget).closest('.project-certification-row').data('cid'),
            model = this.projectBidForm.certifications.get({cid: cid});

        new PJQ.views.customFields.CustomFieldChoicesEditor({
            collection: model.choices,
            isHideSearch: true,
            onSave: _.bind(function (choices) {
                model.set('choices', choices.models);
            }, this)
        });
    },
    newProjectLaborRate: function () {
        this.projectBidForm.set('isChanged', true);
        let newLaborRate = new PJQ.models.bidForms.LaborRate({
            bidFormId: this.projectBidForm.id,
            isNew: true,
            sortOrder: _.size(this.projectBidForm.laborRates) + 1
        });
        this.projectBidForm.laborRates.add(newLaborRate);
        this.projectBidForm.set('laborRates', this.projectBidForm.laborRates);
        this.renderProjectLaborRate(newLaborRate);
    },
    renderProjectLaborRates: function () {
        let projectLaborRates = this.projectBidForm.laborRates.models,
            $gal = this.$('.bid-form-project-labor-rates'),
            self = this;
        $gal.empty();
        _.each(_.sortBy(projectLaborRates, function (laborRate) {
            return laborRate.get('sortOrder');
        }), function (laborRate) {
            self.renderProjectLaborRate(laborRate);
        });
        if (this.options.isEdit) {
            new PJQ.Sortable($gal, {
                items: '.project-labor-rate-row',
                connectWith: '.project-labor-rate-row',
                multiple: true,
                handle: '.project-labor-rate-sort',
                onStop: function () {
                    self.setProjectLaborRateSort();
                }
            });
        }
    },
    renderProjectLaborRate: function (laborRate) {
        let data = {
            item: laborRate,
            isEdit: this.options.isEdit,
            laborRateTypes: PJQ.helpers.bidForms.laborRateTypes
        };
        this.renderSubTemplate(true, this.options.subTemplates.laborRate, this.$('.bid-form-project-labor-rates'), data, function (content) {
            if (laborRate.get('isNew'))
                content.find('.project-labor-rate-description').focus();
        });
    },
    setProjectLaborRateSort: function () {
        let self = this;
        this.$('.project-labor-rate-row').each(function (index) {
            let cid = $(this).data('cid'),
                model = self.projectBidForm.laborRates.get({cid: cid});
            model.set('sortOrder', index + 1);
        });
    },
    projectLaborRateChanged: function (e) {
        let row = $(e.currentTarget).closest('.project-labor-rate-row'),
            cid = row.data('cid'),
            description = row.find('.project-labor-rate-description').val(),
            type = row.find('.project-labor-rate-type').val(),
            isRequired = row.find('.project-labor-rate-required').prop('checked'),
            model = this.projectBidForm.laborRates.get({cid: cid});

        model.set('description', description);
        if (model.get('type') !== type) {
            model.set('type', type);
            this.renderProjectLaborRates();
        }
        model.set('isRequired', isRequired);
    },
    deleteProjectLaborRate: function (e) {
        let cid = $(e.currentTarget).closest('.project-labor-rate-row').data('cid');
        this.projectBidForm.updateLaborRateDeleted(cid, true);
        $(e.currentTarget).closest('.project-labor-rate-row').remove();
    },
    addProjectLaborRateChoices: function (e) {
        let cid = $(e.currentTarget).closest('.project-labor-rate-row').data('cid'),
            model = this.projectBidForm.laborRates.get({cid: cid});

        new PJQ.views.customFields.CustomFieldChoicesEditor({
            collection: model.choices,
            isHideSearch: true,
            onSave: _.bind(function (choices) {
                model.set('choices', choices.models);
            }, this)
        });
    },
    enableEdit: function () {
        this.options.isEdit = true;
        this.render();
    },
    cancelEdit: function () {
        this.options.isEdit = false;
        this.projectBidForm.fetch();
        if (this.model)
            this.model.fetch();
        this.render();
    },
    saveBidForm: function () {
        this.options.isEdit = false;
        this.projectBidForm.save();
        if (this.model) {
            let loader = new PJQ.Loader(this.$el);
            this.model.save(null, {
                success: _.bind(function () {
                    loader.remove();
                    this.render();
                    PJQ.notifications.notify.successNotify({
                        message: 'Bid form saved'
                    });
                }, this),
                error: function () {
                    loader.remove();
                    PJQ.notifications.notify.errorNotify({
                        message: 'Failed to save bid form'
                    });
                }
            });
        }
    }
});

PJQ.views.bidForms.BidFormPreviewModal = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.BIDFORMS, 'Modal-Preview'),
        isEdit: false,
        minWidth: 1000
    },
    events: {
        'click .select-version': 'selectVersion',
        'click .btn-view-drawing': 'viewDrawing',
        'click .btn-download-drawings': 'downloadDrawings'
    },
    beforeModalCreated: function () {
        this.options.canEdit = PJQ.app.session.project.hasPermission('bidForms.isAdmin');
        this.render();
    },
    renderData: function () {
        return {
            model: this.overrideProposal != null ? this.overrideProposal : this.model,
            canEdit: this.options.canEdit && PJQ.app.session.project.get('masterUserId') === PJQ.app.session.get('masterUserId')
        };
    },
    afterRender: function () {
        let proposal = this.overrideProposal != null ? this.overrideProposal : this.model;
        new PJQ.views.bidForms.BidFormViewer({
            el: this.$('.bid-form-viewer'),
            model: proposal,
            modal: this,
            collection: this.collection,
            settings: this.options.settings,
            projectBidForm: this.options.projectBidForm != null ? this.options.projectBidForm : this.model.projectProposal,
            isEdit: this.options.isEdit,
            onEditChange: _.bind(function (isEdit) {
                if (isEdit)
                    this.$('.modal-footer').hide();
                else
                    this.$('.modal-footer').show();
            }, this)
        });
        if (this.model instanceof PJQ.models.bidForms.Proposal) {
            this.renderStatus();
            this.listenTo(this.model, 'change sync', this.renderStatus);
        }
    },
    viewDrawing: function (e) {
        let drawingId = parseInt($(e.currentTarget).data('drawingId')),
            version = null,
            drawing = null;
        _.each(this.versions.models, function (ver) {
            _.each(ver.drawings.models, function (dr) {
                if ((drawing == null || ver.id === -1) && dr.id === drawingId) {
                    version = ver;
                    drawing = dr;
                }
            }, this);
        }, this);
        if (version != null && drawing != null) {
            new PJQ.views.drawings.DrawingViewer({
                model: drawing,
                contextVersion: version,
                versions: this.versions
            });
        }
    },
    downloadDrawings: function () {

    },
    renderStatus: function () {
        if (this.model instanceof PJQ.models.bidForms.Proposal) {
            let statusContainer = this.$('.proposal-status');
            statusContainer.html(this.model.getStatusName());
            statusContainer.parent().css('background-color', this.model.getStatusColor());
        }
    },
    selectVersion: function (e) {
        let proposalId = $(e.currentTarget).data('proposalId');
        if (this.model.id === proposalId) {
            this.overrideProposal = null;
            this.render();
        } else if (this.overrideProposal == null || this.overrideProposal.id !== proposalId) {
            this.overrideProposal = new PJQ.models.bidForms.Proposal({
                proposalId: proposalId
            });
            this.overrideProposal.fetch({
                success: _.bind(function () {
                    this.overrideProposal.bidder = this.model.bidder;
                    this.render();
                }, this)
            });
        }
    }
});

PJQ.views.bidForms.SealedBidContactsModal = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.BIDFORMS, 'Modal-Sealed-Bid-Contacts'),
        isEdit: false,
        projectContacts: null,
        selectedProjectContacts: null,
        onSealBids: _.noop,
        minWidth: 600
    },
    events: {
        'click .btn-seal': 'sealBids'
    },
    renderData: function () {
        return {
            isEdit: this.options.isEdit
        };
    },
    afterRender: function() {
        this.selectedContacts = null;
        new PJQ.views.contacts.ContactsSelectInput({
            el: this.$('.sealed-bid-contacts'),
            contacts: this.options.projectContacts,
            selectedContact: this.options.selectedProjectContacts ? this.options.selectedProjectContacts.models : [],
            isSingleChoice: false,
            disableContacts: true,
            isReadOnly: !this.options.isEdit,
            onChange: _.bind(function (selectedContacts) {
                this.selectedContacts = selectedContacts;
                this.$('.btn-seal').prop('disabled', (_.size(selectedContacts) == 0));
            }, this)
        });

    },
    sealBids: function() {
        new PJQ.views.modals.YesNo({
            header: "Seal Bids",
            body: "Please Note: Only the selected contacts can unseal bids once you continue.  Are you sure you want to seal bids?",
            onYes: _.bind(function () {
                this.options.onSealBids(this.selectedContacts);
                this.removeModal();
            }, this)
        });
    }
});

PJQ.views.bidPackages.CopyBidFormModal = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.BIDFORMS, 'Modal-Copy-From-Bidform'),
        maxWidth: '40%',
        onCopy: _.noop()
    },
    events: {
        'click .copy-bidform': 'copyBidForm'
    },
    beforeModalCreated: function() {
        if (this.options.isBidPackage) {
            this.options.otherBidForms = _.sortBy(this.options.otherBidForms, function (model) {
                return model.get('bidPackage').name;
            })
        } else {
            this.options.otherBidForms = _.sortBy(this.options.otherBidForms, function (model) {
                return model.get('group').groupName;
            })
        }
        this.render();
    },
    renderData: function () {
        return {
            isBidPackage: this.options.isBidPackage,
            otherBidForms: this.options.otherBidForms
        };
    },
    afterRender: function () {
        this.bidFormPicker = new PJQ.inputs.Selectpicker({
            el: $('.bidform-select'),
            isMultiple: false,
            isIntChoices: false,
            defaultValue: this.options.otherBidForms[0].cid
        });

        this.$('.copy-line-items,.copy-alternates,.copy-acknowledgements').on('change', _.bind(function() {
            this.$('.copy-bidform').prop('disabled', !this.$('.copy-line-items').prop('checked') && !this.$('.copy-alternates').prop('checked') && !this.$('.copy-acknowledgements').prop('checked'));
        }, this));
    },
    copyBidForm: function() {
        let selectedBidForm = null;
        _.each(this.options.otherBidForms, _.bind(function(bidForm) {
            if (bidForm.cid === this.bidFormPicker.getValue())
                selectedBidForm = bidForm;
        }, this));

        selectedBidForm.fetch({
            success: _.bind(function (data) {
                let copyLineItems = this.$('.copy-line-items').prop('checked'),
                    copyAlternates = this.$('.copy-alternates').prop('checked'),
                    copyAcknowledgements = this.$('.copy-acknowledgements').prop('checked'),
                    itemCount = 0;

                if (copyLineItems)
                    itemCount += _.size(selectedBidForm.get('lineItems'));

                if (copyAlternates)
                    itemCount += _.size(selectedBidForm.get('alternates'));

                if (copyAcknowledgements)
                    itemCount += _.size(selectedBidForm.get('acknowledgements'));

                if (itemCount === 0) {
                    new PJQ.views.BaseModal({
                        header: "Unable to Copy",
                        body: "The selected " + (this.options.isBidPackage ? 'Bid Package' : 'Trade' ) + " does not contain any data matching your selected options."
                    });
                    return;
                }

                this.options.onCopy(selectedBidForm, copyLineItems, copyAlternates, copyAcknowledgements);

                this.removeModal();
            }, this)
        });
    }
});
